import { Auth } from 'aws-amplify';

export default async function getCurrentAuthenticatedUserIdl() {
  const userToken = await Auth.currentAuthenticatedUser();
  return userToken?.signInUserSession?.idToken?.payload?.identities?.shift()?.userId || userToken?.attributes?.email || userToken?.signInUserSession?.idToken?.payload?.email;
} 